import Wallet from 'mmbclient/razorPay/Wallet'
import React from 'react'
import { RiWallet3Fill } from 'react-icons/ri'

function Nothing() {
  return (
    <div>
      <Wallet></Wallet>
    </div>
  )
}

export default Nothing
